import { Vector3 } from "three";

export default abstract class Element implements ElementDefinitionType {
	id: string;
	color: string;
	type: string;

	constructor({ id, color, type }: { id: string; color: string; type: string }) {
		this.id = id;
		this.color = color;
		this.type = type;
	}
	abstract getParts(): Array<{ position: Vector3; dimensions: Vector }>;
	abstract getBoundingBox(): Vector;
	abstract showInfos(): string;
	abstract cloneWithZoom(zoom: number): Element;
	abstract cloneUpdate(name: string, value: string | number): Element;
	abstract toJson(): ElementDefS;
}
